import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'

export function PlatformPeopleAccountsSkeleton() {
  return (
    <Box
      data-testid="platform-people-accounts-skeleton"
      aria-busy
      aria-label="Loading People and Accounts dashboard"
    >
      <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
        <Skeleton variant="rounded" width={180} height={40} />
        <Skeleton variant="rounded" width={200} height={40} />
        <Skeleton variant="rounded" width={140} height={40} />
      </Box>
      <Typography sx={{ mb: 2 }}>
        <Skeleton width={160} />
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 3, mb: 3 }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={174} />
        ))}
      </Box>
      <Typography sx={{ mb: 2 }}>
        <Skeleton width={180} />
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 3, mb: 3 }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={174} />
        ))}
      </Box>
      <Skeleton variant="rounded" height={480} sx={{ mb: 3 }} />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 3, mb: 3 }}>
        <Skeleton variant="rounded" height={400} />
        <Skeleton variant="rounded" height={400} />
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 3 }}>
        <Skeleton variant="rounded" height={500} />
        <Skeleton variant="rounded" height={500} />
      </Box>
    </Box>
  )
}
